import { render, staticRenderFns } from "./introduction-yoon-head.vue?vue&type=template&id=0de620a2&"
import script from "./introduction-yoon-head.vue?vue&type=script&lang=js&"
export * from "./introduction-yoon-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports